/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const envelope_open_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23 9.737v10.547c0 .373-.166.73-.46.994a1.67 1.67 0 0 1-1.111.412H2.57a1.67 1.67 0 0 1-1.11-.412 1.336 1.336 0 0 1-.46-.994V9.737m22 0-9.059 6.43a3.376 3.376 0 0 1-1.941.601 3.385 3.385 0 0 1-1.941-.6L1 9.737m22 0-8.703-6.845a3.165 3.165 0 0 0-1.045-.66A3.462 3.462 0 0 0 12 2c-.43 0-.857.08-1.252.233a3.16 3.16 0 0 0-1.045.66L1 9.737m14.99 4.976 3.081 2.758m-11.06-2.758-3.082 2.758"
    />
  </svg>
)
export default envelope_open_medium
